import React, { createContext, useState } from 'react';
import { toast } from 'react-toastify';
import { useTenant } from 'contexts/tenant';

export const SubscriptionPurchaseContext = createContext({
  module_code: '',
  show_modal: false,
  setModuleCode: () => {},
  closeModal: () => {},
  openModal: () => {}
});

export const SubscriptionPurchaseProvider = ({ children }) => {
  const { is_agency_managed } = useTenant();
  const [module_code, setModuleCode] = useState('');
  const [show_modal, setShowModal] = useState(false);

  const closeModal = () => {
    setShowModal(false);
  };

  const openModal = () => {
    if (is_agency_managed) {
      toast.info('Your subscription is managed by your agency.');
      return;
    }
    setShowModal(true);
  };

  return (
    <SubscriptionPurchaseContext.Provider
      value={{ module_code, show_modal, setModuleCode, closeModal, openModal }}
    >
      {children}
    </SubscriptionPurchaseContext.Provider>
  );
};
